var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['contractPage', {'full-screen': _vm.fullScreen}]},[(_vm.showPageTitle)?_c('header',{staticClass:"pageTitle"},[_c('h2',[_vm._v(_vm._s(_vm.pageTitle))])]):_vm._e(),_c('div',{staticClass:"content-page",domProps:{"innerHTML":_vm._s(_vm.pageData)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }